import * as Sentry from "@sentry/react";
Sentry.init({
  dsn: "https://6812fde32a0e5ec78a11dec2a962f5ac@o330503.ingest.us.sentry.io/4507185381572608",
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
  integrations: [
  ],
});